import IndividualTable from "../../../IndividualTable";
import { sampleData } from "../../sampleData";

const Distance90 = () => {
  let winners = [
    "431", "220", "366", "512"
  ];
  return <IndividualTable matchType={"8"} gender="M" event="90" subTitle="TarscaShild" data={sampleData} topRankCount="4" winners={winners} />;
};
export default Distance90;
